import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import { useAddToCart } from '../../../api/shoppingCart';
import AddToCartButtonToQty from '../../../components/AddToCartButtonToQty';

export interface CataloguePageListContentItemCardAddToCartProps
  extends StandardDivProps<CataloguePageListContentItemCardAddToCartClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardAddToCartClassKey = 'root';

const themeSettings = { name: 'CataloguePageListContentItemCardAddToCart' };
const useStyles = makeStyles(
  createStyles<CataloguePageListContentItemCardAddToCartClassKey | 'qfWrapper', {}>({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    qfWrapper: {
      justifyContent: 'flex-end',
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemCardAddToCart = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardAddToCartProps
>(({ className, classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });

  const { addToCart, ...addToCartProps } = useAddToCart({
    forcePreventDecrement: true,
    product,
  });

  return (
    <div ref={ref} className={clsx(classes.root, className)}>
      <AddToCartButtonToQty
        onAddToCart={addToCart}
        {...addToCartProps}
        product={product}
        QuantityFieldProps={{
          classes: {
            wrapper: classes.qfWrapper,
          },
        }}
      />
    </div>
  );
});

CataloguePageListContentItemCardAddToCart.displayName = 'CataloguePageListContentItemCardAddToCart';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardAddToCart);
